import type { Feature, FeatureCollection, Geometry } from 'geojson'

// Mirrors GEOJSON_VERSION in pinvision-api: libs/pinvision-lib/src/dto/golfclub-geojson.dto.ts
// Bump this in lockstep whenever the API bumps its constant.
export const GOLFCLUB_GEOJSON_VERSION = '2.0.3'

export enum GeojsonFeatureType {
  Golfclub = 'golfclub',
  Course = 'course',
  Hole = 'hole',
  Rough = 'rough',
  Fairway = 'fairway',
  Teebox = 'teebox',
  Teeboxcenter = 'teeboxcenter',
  Crosscenter = 'crosscenter',
  Greencenter = 'greencenter',
  Green = 'green',
  Centralpath = 'centralpath',
  Slopearrow = 'slopearrow',
  Slopeline = 'slopeline',
  Cross = 'cross',
  Building = 'building',
  Bunker = 'bunker',
  Street = 'street',
  Vegetation = 'vegetation',
  Tree = 'tree',
  Water = 'water',
  Bridge = 'bridge',
  Poi = 'poi',
}

export enum PoiCategory {
  Restaurant = 'restaurant',
  Proshop = 'proshop',
  Toilet = 'toilet',
}

export interface IGolfclubGeojsonFeatureProperties {
  type: GeojsonFeatureType
  id?: number
  id_course?: number
  name?: string
  number?: number
  angle?: number
  angle_green?: number
  category?: PoiCategory
}

export interface IGolfclubGeojsonMetadata {
  last_update: string
  version: string
  copyright: string
}

export type GolfclubGeojsonFeature = Feature<Geometry, IGolfclubGeojsonFeatureProperties>

// `bbox` is already declared on GeoJsonObject (which FeatureCollection extends);
// `metadata` is the only genuine RFC7946 foreign-member addition here.
export interface IGolfclubGeojsonFeatureCollection extends FeatureCollection<
  Geometry,
  IGolfclubGeojsonFeatureProperties
> {
  metadata?: IGolfclubGeojsonMetadata
}
